import { reactive } from "vue";

import DeliveryHelper from "@/helper/DeliveryHelper.js";
import { DeliveryMethodModel } from '@/module/DeliveryMethod/model/DeliveryMethodModel.js';
import { AddressListModel } from '@/core/Address/model/AddressListModel.js';
// service
import BKDeliveryMethod from "@/module/DeliveryMethod/service/BKDeliveryMethod.js";

const state = reactive({
    isInitialDelivery: false,

    delivery: null,
    isFromDeliveryMethod: false,
    address: null,
    taxAddress: null,
});

const methods = {
    // DeliveryMethod
    init: function() {
        state.isInitialDelivery = false;
        if (DeliveryHelper.isDelivery()) {
            let cacheDelivery = DeliveryHelper.getCacheDelivery();
            state.delivery = new DeliveryMethodModel();
            state.delivery.setValueFormCache(cacheDelivery);
            
            state.isInitialDelivery = true;
        } else {
            BKDeliveryMethod.apiGetCartDelivery().subscribe({
                next: (data) => {
                    this.updateDelivery(data);
                    state.isInitialDelivery = true;
                },
                error: (err) => {
                    state.isInitialDelivery = true;
                    console.log(err);
                },
            });
        }
        
    },
    getDelivery: function() {
        state.isInitialDelivery = false;
        BKDeliveryMethod.apiGetCartDelivery().subscribe({
            next: (data) => {
                this.updateDelivery(data);
                state.isInitialDelivery = true;
            },
            error: (err) => {
                state.isInitialDelivery = true;
                console.log(err);
            },
        });
    },
    getDeliveryFromCache: function() {
        state.isInitialDelivery = false;
        let cacheDelivery = DeliveryHelper.getCacheDelivery();
        state.delivery = new DeliveryMethodModel();
        state.delivery.setValueFormCache(cacheDelivery);
        
        state.isInitialDelivery = true;
    },
    updateDelivery: function(delivery) {
        state.delivery = {...delivery};
        state.isFromDeliveryMethod = false;
        DeliveryHelper.setCacheDelivery(delivery);
    },
    removeDelivery: function() {
        state.delivery = null;
        state.isFromDeliveryMethod = false;
        DeliveryHelper.removeCacheDelivery();
    },
    
    updateIsFromDeliveryMethod: function(isFromDeliveryMethod) {
        state.isFromDeliveryMethod = isFromDeliveryMethod;
    },


    //address
    initAddress: function() {
        state.address = new AddressListModel();
    },
    initTaxAddress: function() {
        state.taxAddress = new AddressListModel();
    },
    removeAddress: function() {
        state.address = null;
    },
    removeTaxAddress: function() {
        state.taxAddress = null;
    }
};


export default {
    state: state,
    methods: methods,
}
